import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const faqs = [{
  q: '¿Necesito experiencia previa para empezar?',
  a: 'No. El programa está diseñado para comenzar completamente desde cero. No importa tu condición física actual ni cuánto tiempo llevas sin hacer ninguna actividad. Todo empieza de forma gradual y a tu ritmo.'
}, {
  q: '¿Cuánto tiempo por día necesito dedicarle?',
  a: 'Con 15 a 20 minutos diarios es más que suficiente. El plan está pensado especialmente para personas con agenda ocupada que buscan resultados reales sin sacrificar horas de su día.'
}, {
  q: '¿Necesito equipo especial o ir al gimnasio?',
  a: 'No. Todas las rutinas están diseñadas para hacerse en casa, con tu propio cuerpo. Sin equipamiento, sin maquinaria. Solo necesitás un poco de espacio en el piso.'
}, {
  q: '¿Cuánto tiempo tengo acceso al contenido?',
  a: 'El acceso es de por vida. Una vez que te inscribís, todo el contenido es tuyo para siempre, incluyendo todas las actualizaciones que se agreguen en el futuro.'
}, {
  q: '¿Cuándo voy a empezar a ver resultados?',
  a: 'Muchas personas reportan mejoría desde los primeros días. Los cambios más sólidos y duraderos se notan entre la primera y la tercera semana de práctica constante.'
}, {
  q: '¿Hay garantía si no quedo satisfecho/a?',
  a: 'Absolutamente. Ofrecemos 30 días de garantía total. Si por cualquier motivo el programa no es lo que esperabas, te devolvemos el dinero completo sin preguntas, sin formularios y sin complicaciones.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section id="faq" bg="bg-white" className="max-w-3xl" data-id="element-25" data-mp="z1cwmr64ed68">
      <Reveal data-id="element-26" data-mp="z1mrot60vais">
        <SectionHeading title="Preguntas frecuentes" data-id="element-27" data-mp="z3h3nhzbfsaq" />
      </Reveal>

      <div className="mt-10 space-y-3" data-id="element-28" data-mp="u3l6a1l4iz45">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <Reveal key={f.q} index={i} data-id="element-29" data-mp="1jsi6hevbmstf" data-mpi={i}>
              <div className="overflow-hidden rounded-2xl border border-sand-200 bg-sand-50" data-id="element-30" data-mp="1nr8xr5d3vg8m">
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-sand-100/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-400" data-id="element-31" data-mp="1sqke4d9k8jpo">
                  <span className="font-display text-base font-semibold text-forest-800 sm:text-lg" data-id="element-32" data-mp="26os94fn1day7">
                    {f.q}
                  </span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-forest-500 text-white transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-33" data-mp="2ggxz5jtq9iar">
                    <PlusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-34" data-mp="erilrrwhzdfd" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-35" data-mp="9rwb9q820ba9">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-36" data-mp="4t2vts97ia7g">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-forest-700/75" data-id="element-37" data-mp="sidqqt3vlado">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}